import React from 'react';
import uuidv4 from 'uuid';
import PropTypes from 'prop-types';

//material ui:
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';


const styles = theme => ({
    root: {
        height: '100%',
        width: 240,
    },
    containerPair: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        minWidth: 520,
    },
    formControl: {
        display: 'flex',
        justifyContent: 'center',
        margin: '5px 25px',
        minWidth: 120,
        height: 72,
        width: 185,
    },
    buttonsContainer: {
        width: 520,
        padding: '25px 0 0 25px'
    },
    buttonsBottom: {
        marginRight: 15,
        padding: '10px 4%',
        borderRadius: 0,
        textTransform: 'capitalize',
        color: 'white',
        border: 'none',
        boxShadow: 'none',
    },
});

class EditZonaProductCaja extends React.Component {

    constructor(props) {
        super(props);

        this.state = {

            id: this.props.producto.id ? this.props.producto.id : uuidv4(),
            elemId: this.props.elemCajaId ? this.props.elemCajaId : 0,
            descr: this.props.producto.descr ? this.props.producto.descr : this.props.allproductos[0].descr,
            ctaDebe: this.props.producto.ctaDebe ? this.props.producto.ctaDebe : '',
            ctaHaber: this.props.producto.ctaHaber ? this.props.producto.ctaHaber : '',
            ctaIva: this.props.producto.ctaIva ? this.props.producto.ctaIva : '',
            iTipoArticulo: this.props.producto.iTipoArticulo ? this.props.producto.iTipoArticulo : this.props.allproductos[0].id,
            activo: this.props.producto.activo ? true : false,
            iTipoZonaIva: this.props.producto.iTipoZonaIva ? this.props.producto.iTipoZonaIva : null,
            tipoZonaIva: this.props.producto.tipoZonaIva ? this.props.producto.tipoZonaIva : ''

        };

    };




    //get textfields changes:
    handleValueChange = (event, field) => {
        this.setState({ ...this.state, [field]: event.target.value });
    };

    //get select changes:
    handleChangeTipoPartidaSelect = (event) => {

        const value = parseInt(event.target.value);

        this.setState({
            ...this.state,
            iTipoArticulo: value,
            descr: this.props.allproductos.find(p => p.id === value).descr
        });
    };

    handleChangeTipoZonaIVASelect = (event) => {

        const value = parseInt(event.target.value);
        const tipoZonaIva = this.props.tipoZonaIva.tiposzona.find(p => p.id === value);

        this.setState({
            ...this.state,
            iTipoZonaIva: value,
            tipoZonaIva: tipoZonaIva?tipoZonaIva.descr:''
        });
    };

    compareDescr = (a, b) => {
        if (a.descr < b.descr)
            return -1;
        if (a.descr > b.descr)
            return 1;
        return 0;
    };

    fillTiposProductos = () => {


        return [...this.props.allproductos].sort(this.compareDescr).filter(p => p.isMovCaja === 1).map(p => {

            return (
                <option key={p.id} value={p.id}>{p.descr}</option>
            );

        })
    };

    //get checkbox changes:
    handleCheckboxChange = event => {
        this.setState({ activo: event.target.checked });
    };

    render() {
        const { classes } = this.props;

        return (
            <div className={classes.root}>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="iTipoArticulo-placeholder">
                            Tipo Cobro
                                </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoArticulo}
                            onChange={(event) => this.handleChangeTipoPartidaSelect(event)}
                            name="iTipoArticulo"
                        >
                            {this.fillTiposProductos()}
                        </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'ctaDebe'}
                            label={'Debe'}
                            placeholder={'Debe'}
                            margin="normal"
                            value={this.state.ctaDebe}
                            onChange={(event) => this.handleValueChange(event, 'ctaDebe')}
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'ctaHaber'}
                            label={'Haber'}
                            placeholder={'Haber'}
                            margin="normal"
                            value={this.state.ctaHaber}
                            onChange={(event) => this.handleValueChange(event, 'ctaHaber')}
                        />
                    </FormControl>

                    <FormControl className={classes.formControl}>

                        <TextField
                            id={'ctaIva'}
                            label={'IVA'}
                            placeholder={'IVA'}
                            margin="normal"
                            value={this.state.ctaIva}
                            onChange={(event) => this.handleValueChange(event, 'ctaIva')}
                        />
                    </FormControl>
                </div>

                <div className={classes.containerPair}>
                    <FormControl className={classes.formControl}>
                        <InputLabel id="id-select-outlined-label" >
                            Zona Tipo IVA
                            </InputLabel>
                        <Select
                            native
                            value={this.state.iTipoZonaIva}
                            onChange={(event) => this.handleChangeTipoZonaIVASelect(event)}
                        >
                            <option key={0} value={null}>Sin tipo de zona</option>
                            {this.props.tipoZonaIva.tiposzona.map(l => (
                                <option key={l.id} value={l.id}>{l.descr}</option>
                            ))}
                        </Select>
                    </FormControl>

                    <FormControl className={classes.formControl}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={this.state.activo}
                                    onChange={this.handleCheckboxChange}
                                    // value="iTipoArticulo"
                                    color="primary"
                                />
                            }
                            label="Activo"
                        />
                    </FormControl>
                </div>

                <div className={classes.buttonsContainer}>
                    <Button className={classes.buttonsBottom} variant="contained" color="secondary" onClick={() => this.props.hideDialog()}>Cerrar</Button>
                    <Button className={classes.buttonsBottom} variant="contained" color="primary" onClick={() => {
                        const producto = {
                            ...this.props.producto,
                            id: this.state.id,
                            elemId: this.state.elemId,
                            descr: this.state.descr,
                            ctaDebe: this.state.ctaDebe,
                            ctaHaber: this.state.ctaHaber,
                            ctaIva: this.state.ctaIva,
                            activo: this.state.activo ? 1 : 0,
                            iTipoArticulo: this.state.iTipoArticulo,
                            iTipoZonaIva: this.state.iTipoZonaIva,
                            tipoZonaIva: this.state.tipoZonaIva,
                        };

                        if (this.props.checkProductoCaja(producto)) {

                            this.props.okHandler(producto);
                            this.props.hideDialog();
                        };
                    }
                    }>Guardar</Button>
                </div>

            </div>
        );

    };


};

EditZonaProductCaja.propTypes = {
    producto: PropTypes.object.isRequired,
    zonaProductosCaja: PropTypes.object.isRequired,
    allproductos: PropTypes.array.isRequired,
    tipoZonaIva: PropTypes.array.isRequired,
    elemCajaId: PropTypes.number.isRequired,
    okHandler: PropTypes.func.isRequired,
    checkProductoCaja: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
};


export default withStyles(styles, { withTheme: true })(EditZonaProductCaja);